import Vue from "vue";
import { generateUUID, deepClone, sleep } from "@/utils";
import { baseURL_WSS } from "@/utils/request";
import { assistantDetail } from "@/api/aiHelper";

const stoppingText = "终止中...";

const toolItem = {
  chatList: [],
  currentChat: undefined,
  status: 0, // 0完成 1 响应中 2 响应失败或错误 3响应中断 4响应等待
  type: 1,
  toolId: -1,
  toolDetail: {},
  uuId: generateUUID(),
  socketTask: undefined,
  // 是否主动断开链接
  isProactiveDisconnect: false,
  // 心跳包计数
  pingCount: 0,
  pingTimerId: undefined,
  toastData: {
    visible: false,
    tips: ""
  },
  startPingTimer() {
    this.pingCount = 0;
    clearInterval(this.pingTimerId);
    this.pingTimerId = setInterval(() => {
      if (this.status !== 1 && this.status !== 5) {
        this.socketTask?.send(`ping`);
        this.pingCount++;
      }
      // 2次ping没有回复pong 重新链接
      if (this.pingCount > 1) {
        // 重新链接
        this.connect(true);
        clearInterval(this.pingTimerId);
        if (
          this.currentChat?.status === 4 ||
          this.currentChat?.text === stoppingText
        ) {
          this.status = 2;
          this.currentChat.status = 2;
          this.currentChat.tokenTotal = 0;
          this.currentChat.text = "当前排队用户过多，请稍后重试。";
        }
      }
    }, 5000);
  },
  // 接收定时器 超过35秒没有响应 结束本条会话 后端也做了超时30秒
  responseTimerId: undefined,
  startResponseTimer() {
    this.pingCount = 0;
    clearTimeout(this.responseTimerId);
    this.responseTimerId = setTimeout(() => {
      clearTimeout(this.responseTimerId);
      if (this.currentChat) {
        this.status = 2;
        this.currentChat.status = 2;
        this.currentChat.tokenTotal = 0;
        this.currentChat.text = "当前排队用户过多，请稍后重试。";
      }
    }, 35000);
  },
  clearResponseTimer() {
    clearTimeout(this.responseTimerId);
  },
  // 链接socket
  connect(flag = false) {
    console.log("connect");
    const applicationIdentity = state.applicationIdentity;
    const token = state.token;
    // 为正常链接状态
    if (this.socketTask?.readyState === 1 && !flag) {
      return Promise.resolve(true);
    }
    /*  socketTask.readyState  
      0 (WebSocket.CONNECTING)正在链接中 
      1 (WebSocket.OPEN)已经链接并且可以通讯
      2 (WebSocket.CLOSING)连接正在关闭
      3 (WebSocket.CLOSED)连接已关闭或者没有链接成功
    */
    this.socketTask = new WebSocket(
      `${baseURL_WSS}/ws?thirdApplicationId=${applicationIdentity}&token=${token}`
    );
    return new Promise(resolve => {
      if (!this.socketTask) {
        resolve(false);
        return;
      }
      this.socketTask.onopen = () => {
        console.log("open");
        this.socketTask?.send(`connect`);
        this.startPingTimer();
        resolve(true);
      };
      this.socketTask.onerror = () => {
        resolve(false);
      };
      this.socketTask.onmessage = ev => {
        this.onmessage(ev);
      };
    });
  },
  // 断开链接
  async disconnect() {
    if (!this.socketTask) return;
    if (this.socketTask.readyState === 1) {
      // 用于标记 控制台好看日志
      this.socketTask.send(`disconnect`);
    }
    await sleep();
    this.socketTask.close(1000);
  },
  // 检查是否为响应中状态
  isResponding() {
    if (this.status === 1 || this.status === 4) {
      this.toastData.tips = "正在回答，请稍后再试";
      this.toastData.visible = true;
      return true;
    }
    if (this.status === 5) {
      this.toastData.tips = "终止中，请稍后再试";
      this.toastData.visible = true;
      return true;
    }
    return false;
  },
  // 发送消息
  async send(params) {
    if (this.isResponding()) return;
    const msgId = generateUUID();
    const q = {
      text: params.question,
      parsedText: params.parsedQuestion,
      status: 0,
      type: 0,
      id: generateUUID(),
      groupId: msgId,
      uuId: this.uuId,
      context: "",
      contextLoading: false
    };
    const a = {
      text: "正在思考",
      status: 4,
      type: 1,
      id: msgId,
      groupId: msgId,
      tokenTotal: undefined,
      uuId: this.uuId,
      docCount: 0
    };
    this.status = 4;
    const data = {
      code: this.type,
      msg: {
        msg: params.parsedQuestion || params.question,
        uuid: this.uuId,
        /**@cmd
          0后台调试消息
          1前端发送消息
          2终止消息
          3重试消息
          4删除消息
        **/
        cmd: params.type || 0,
        assistantId: this.toolId,
        msgId: msgId
      }
    };
    this.chatList.push({
      id: msgId,
      q,
      a: [a]
    });
    this.currentChat = a;
    await this.connect();
    this.socketTask?.send(JSON.stringify(data));
    return true;
  },
  // 删除选中的聊天记录
  async deleteRecord(groupId) {
    const currentChatGroup = this.chatList.find(item => item.id === groupId);
    if (!currentChatGroup) return;
    const qChat = currentChatGroup.q;
    const aChat = currentChatGroup.a[0];
    this.chatList = this.chatList.filter(item => item.id !== groupId);
    const data = {
      code: this.type,
      msg: {
        msg: qChat.parsedText || qChat.text,
        uuid: aChat.uuId,
        cmd: 4,
        assistantId: this.toolId,
        msgId: aChat.id
      }
    };
    await this.connect();
    this.socketTask?.send(JSON.stringify(data));
    return true;
  },
  // 重新回答
  async reSend(groupId, aChatId) {
    if (this.isResponding()) return;
    const currentChatGroup = this.chatList.find(item => item.id === groupId);
    if (!currentChatGroup) return;
    const qChat = currentChatGroup.q;
    const aChat = currentChatGroup.a.slice(-1)[0];
    const newAChat = {
      text: "正在思考",
      status: 4,
      type: 1,
      id: generateUUID(),
      groupId,
      tokenTotal: undefined,
      uuId: this.uuId,
      docCount: 0
    };
    this.status = 4;
    currentChatGroup.a.push(newAChat);
    this.currentChat = newAChat;
    const data = {
      code: this.type,
      msg: {
        msg: qChat.parsedText || qChat.text,
        uuid: this.uuId,
        cmd: 3,
        assistantId: this.toolId,
        msgId: newAChat.id,
        // 重试回答消息的id
        retryMsgId: aChatId || aChat.id
      }
    };
    await this.connect();
    this.socketTask?.send(JSON.stringify(data));
    this.startResponseTimer();
    return true;
  },
  // 重新开始
  reStart() {
    if (this.isResponding()) return;
    if (this.chatList.slice(-1)[0]?.extraType === 0) {
      this.toastData.tips = "已经是新对话了，我们继续吧~";
      this.toastData.visible = true;
      return;
    }
    this.uuId = generateUUID();
    const chat = {
      text: "已开启全新会话",
      status: 0,
      type: -1,
      id: this.uuId,
      groupId: this.uuId,
      uuId: this.uuId
    };
    // 添加一个表示分割线的数据
    this.chatList.push({
      extraType: 0,
      id: this.uuId,
      q: chat,
      a: [chat]
    });
  },
  // 设置问答的上下文
  setContext({ groupId, context, contextLoading }) {
    const currentChatGroup = this.chatList.find(item => item.id === groupId);
    if (!currentChatGroup) return;
    const qChat = currentChatGroup.q;
    qChat.context = context;
    qChat.contextLoading = contextLoading;
  },
  // 接受消息
  onmessage(e) {
    let data = e.data;
    try {
      data = JSON.parse(data);
    } catch {
      //
    }
    // 心跳回复
    if (typeof data === "string") {
      if (data === "pong") {
        this.pingCount--;
      }
      return;
    }
    const { msg = "", tag, uuid } = data;
    // 是否为本条工具的对话
    if (uuid !== this.uuId) return;
    const chat = this.currentChat;
    if (!chat) return;
    // 系统标签
    if (tag === "systemTag") {
      // 拼接图文
      const { imageList, replyContext } = msg;
      chat.text = replyContext;
      chat.imageList = imageList;
      return;
    }
    // 已停止回答
    if (tag === "stop") {
      if (!chat.text || chat.text === stoppingText) {
        chat.status = 3;
        chat.text = msg || "已终止回答";
        chat.stoped = 1;
        this.status = 3;
        this.clearResponseTimer();
      }
      return;
    }
    // 开始
    if (tag === "start") {
      chat.text = "";
      chat.status = 1;
      this.status = 1;
      return;
    }
    // 错误
    if (tag === "textError") {
      chat.text += msg;
      chat.tokenTotal = 0;
      chat.status = 2;
      this.status = 2;
      this.clearResponseTimer();
      return;
    }
    // 附加字段
    if (tag === "usage") {
      chat.tokenTotal = msg.c;
      return;
    }
    // 引用文档
    if (tag === "doc") {
      chat.docCount = msg.length;
      return;
    }
    // 非传输中
    if (this?.status !== 1 && this?.status !== 5) return;
    // 结束了更新状态
    if (tag === "end") {
      chat.status = 0;
      this.status = 0;
      // 接收完成后清除定时器
      this.clearResponseTimer();
    } else {
      // 传输中字符串累加
      chat.text += msg;
      //每次接收重置定时器
      this.startResponseTimer();
    }
  },
  // 停止响应
  stop(groupId) {
    // 当前类型的聊天记录
    if (groupId) {
      this.currentChat = this.chatList
        .find(item => item.id === groupId)
        ?.a.slice(-1)[0];
    }
    const chat = this.currentChat;
    if (!chat) return;
    if (chat.status === 4) {
      chat.text = stoppingText;
    }
    chat.status = 5;
    this.status = 5;
    const data = {
      code: this.type,
      msg: {
        uuid: this.uuId,
        cmd: 2,
        msgId: chat.id,
        assistantId: this.toolId
      }
    };
    this.socketTask?.send(JSON.stringify(data));
    this.startResponseTimer();
  },
  // 清除记录
  clear() {
    this.chatList.length = 0;
    this.status = 0;
    this.currentChat = undefined;
    // 清除后重新获取工具详情添加引导语
    this.getToolDetail();
  },
  // 获取工具详情
  getToolDetail() {
    assistantDetail({ id: this.toolId }).then(res => {
      if (res) {
        this.toolDetail = res;
        // 将引导语追加到列表
        if (this.toolDetail.assistantExt?.welcomeMessage) {
          if (!this.chatList.length) {
            this.unshiftChat({
              type: 1,
              text: this.toolDetail.assistantExt?.welcomeMessage
            });
          }
        }
      }
    });
  },
  // 往头部添加chat
  unshiftChat({ list, type, text }) {
    if (typeof type === "number" && text) {
      const id = generateUUID();
      const chat = {
        text,
        status: 0,
        type: -1,
        id: id,
        groupId: id,
        uuId: id
      };
      this.unshiftChat({
        list: [
          {
            extraType: type,
            id: id,
            q: chat,
            a: [chat]
          }
        ]
      });
    } else if (list) {
      this.chatList = list.concat(this.chatList);
    }
  }
};

const state = {
  applicationIdentity: "",
  token: "",
  toolMap: {}
};
const mutations = {
  INIT(state, { toolId, type, applicationIdentity, token }) {
    state.applicationIdentity = applicationIdentity;
    state.token = token;
    if (!state.toolMap[toolId]) {
      Vue.set(state.toolMap, toolId, deepClone(toolItem));
    }
    const tool = state.toolMap[toolId];
    tool.type = type;
    tool.uuId = generateUUID();
    tool.toolId = toolId;
    tool.connect();
    tool.getToolDetail();
  },
  SET_TOAST_DATA(state, params) {
    if (state.toolMap[params.toolId]) {
      state.toolMap[params.toolId].toastData = params;
    }
  }
};
export default {
  namespaced: true,
  state,
  mutations
};
